/* eslint-disable no-plusplus */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-syntax */
import React, { useContext, useEffect, useRef, useState } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CompareArrowsIcon from "@material-ui/icons/CompareArrows";
import HistoryIcon from "@material-ui/icons/History";
import InsertChartIcon from "@material-ui/icons/InsertChart";
import { useHistory } from "react-router-dom";
import CreateIcon from "@material-ui/icons/Create";
import { ReactComponent as ProductIcon } from "../../assets/icons/product.svg";
import { ReactComponent as SubstrateIcon } from "../../assets/icons/substrate.svg";
import { ReactComponent as ProductIconActive } from "../../assets/icons/product-active.svg";
import { ReactComponent as SubstrateIconActive } from "../../assets/icons/substrate-active.svg";
import SubstrateTab from "./SubstrateTab/SubstrateTab";
import ProductTab from "./ProductTab/ProductTab";
import TestTab from "./TestTab/TestTab";
import ProductProvider from "../../contexts/ProductContext";
import TestSeriesProvider from "../../contexts/TestSeriesContext";
import ReportTab from "./ReportTab/ReportTab";
import TestRequestApi from "../../api/services/TestRequestApi";
import SubstrateSampleProvider from "../../contexts/SubstrateSampleContext";
import { TestRequestContext } from "../../contexts/TestRequestContext";
import { tesaBlue, tesaGrey1, tesaGrey4 } from "../../styles/colors";
import { NavigationContext } from "../../contexts/NavigationContext";
import ErrorSnackbarContext from "../../contexts/ErrorSnackbarContext";
import TestRequestPermissionContext from "../../contexts/TestRequestPermissionContext";
import { TestPlanPermissionContextProvider } from "../../contexts/TestPlanPermissionContext";
import useEnv from "../../hooks/env";
import StatusChip from "../../components/Chip/StatusChip";
import useTestRequestParams, { TestRequestTabType } from "./useTestRequestParams";
import BackgroundInformationApi from "../../api/services/BackgroundInformationApi";
import CustomProgress from "../../components/Alert/CustomProgress";
import DescriptionFormType from "./DescriptionTab/models/Description.form";
import UrlParameters from "./models/UrlParameters.model";
import mapFromUrlParams from "./DescriptionTab/models/Description.url-mapper";
import EditRequestNameDialog from "../Dashboard/EditRequestNameDialog";
import HistoryTab from "./HistoryTab/HistoryTab";
import RequestFlagIconList from "../../components/RequestFlags/RequestFlagIconList";
import DescriptionTab from "./DescriptionTab/DescriptionTab";
import AproeProjectTab from "./AproeProjectTab/AproeProjectTab";
import ProjectIcon from "./ProjectIcon";
import ProjectIconActive from "./ProjectIconActive";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  headerContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(2),
    "& > * + *": {
      marginRight: theme.spacing(2),
    },
  },
  createIcon: {
    color: tesaGrey4,
    height: "16px",
    width: "16px",
    "&:hover": {
      color: tesaBlue,
      cursor: "pointer",
    },
  },
  h1: {
    margin: 0,
    overflow: "hidden",
    paddingRight: theme.spacing(2),
    textOverflow: "ellipsis",
    "&:empty": {
      paddingRight: 0,
    },
  },
  subHeader: {
    color: tesaGrey1,
    fontSize: "12px",
    paddingLeft: theme.spacing(3),
  },
  innerRoot: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  paddingInset: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  icon: {
    fontSize: "1rem",
  },
  iconSvg: {
    height: "1rem",
    width: "1rem",
    "$&path": {},
  },
  tab: {
    minWidth: 96,
  },
}));

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number): { [key: string]: string } {
  return {
    id: `create-request-${index}`,
    "aria-controls": `create-request-panel-${index}`,
  };
}

const RequestsPage = () => {
  const { api } = useEnv();
  const testRequestApi: TestRequestApi = new TestRequestApi(api);
  const backgroundInformationApi: BackgroundInformationApi = new BackgroundInformationApi(api);
  const classes = useStyles();
  const { dirtyFlag, preventNav } = useContext(NavigationContext);
  const { handleHttpError } = useContext(ErrorSnackbarContext);
  const {
    accessDescription,
    accessSubstrateSamples,
    accessProductSamples,
    accessTestPlan,
    accessReports,
    accessHistory,
    accessProjectInfo,
    viewSubstrateSamples,
    viewProductSamples,
    viewTestPlan,
    viewReports,
    viewHistory,
    viewProjectInfo,
  } = useContext(TestRequestPermissionContext);
  const {
    testRequestObj,
    testRequestTitleSuffix,
    updateTestRequestTitleSuffix,
    updateTestRequestObj,
    updateTestRequestHistorical,
    resetTestRequestContext,
  } = useContext(TestRequestContext);
  const history = useHistory();
  const { testRequestId, tab } = useTestRequestParams();

  const reassignTabValue = (tabType: TestRequestTabType) => {
    if (tabType === TestRequestTabType.HISTORY && !accessHistory) {
      return TestRequestTabType.REPORT;
    }
    if (tabType === TestRequestTabType.APROE_PROJECT && testRequestObj?.purpose === "APPLICATION_PROCESS") {
      return 1;
    }
    return tabType;
  };

  const [value, setValue] = React.useState(reassignTabValue(tab));
  const [loading, setLoading] = React.useState(true);
  const [initialValuesFromUrl, setInitialValuesFromUrl] = useState<DescriptionFormType>();
  const [isNameDialogOpen, setIsNameDialogOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const previousConfidentiality = useRef<string | null | undefined>(undefined);

  const createMode = testRequestId === "new";

  useEffect(() => {
    const currentConfidentiality = testRequestObj?.description?.projectConfidentiality ?? null;

    if (previousConfidentiality.current === undefined) {
      previousConfidentiality.current = currentConfidentiality;
      return;
    }

    if (previousConfidentiality.current !== currentConfidentiality) {
      previousConfidentiality.current = currentConfidentiality;
      setRefreshKey((prev) => prev + 1);
    }
  }, [testRequestObj?.description?.projectConfidentiality]);

  const parseUrlParams = (): [boolean, UrlParameters] => {
    const queryString = window.location.search;
    const paramsObj: UrlParameters = {};
    if (!queryString) {
      return [false, paramsObj];
    }

    const urlParams = new URLSearchParams(queryString);
    for (const pair of urlParams.entries()) {
      const paramName = pair[0] as keyof UrlParameters;

      if (paramsObj) {
        paramsObj[paramName] = pair[1];
      }
    }

    return [true, paramsObj];
  };

  const initialize = () => {
    updateTestRequestObj({});
    updateTestRequestTitleSuffix("");
    updateTestRequestHistorical(false);
    setLoading(false);
  };

  const initializeFromSaved = () => {
    testRequestApi
      .getTestRequest(testRequestId)
      .then(({ data }) => {
        if (data) {
          updateTestRequestObj(data);
          updateTestRequestTitleSuffix(data.description?.title || "");
          updateTestRequestHistorical(data.historical || false);
        }
      })
      .catch((e) => {
        resetTestRequestContext();
        handleHttpError(e);
      })
      .finally(() => setLoading(false));
  };

  const initializeFromUrlParams = (urlParams: UrlParameters) => {
    updateTestRequestObj(urlParams.aproe ? { purpose: "APPLICATION_PROCESS" } : {});
    updateTestRequestTitleSuffix(urlParams.name || "");
    updateTestRequestHistorical(urlParams.historical === "1");
    if (urlParams.country && urlParams.customerid) {
      backgroundInformationApi
        .findCustomer(urlParams.country || "", urlParams.customerid || "")
        .then((res) => res.data)
        .catch((error) => {
          handleHttpError(error);
        })
        .then((res) => res || null)
        .then((res) => mapFromUrlParams(urlParams, res, res?.country || null))
        .then((generatedValues) => {
          setInitialValuesFromUrl(generatedValues);
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (urlParams.country) {
      backgroundInformationApi
        .findCountry(urlParams.country || "")
        .then((res) => res.data)
        .catch((error) => {
          handleHttpError(error);
        })
        .then((res) => res || null)
        .then((res) => mapFromUrlParams(urlParams, null, res))
        .then((generatedValues) => {
          setInitialValuesFromUrl(generatedValues);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setInitialValuesFromUrl(mapFromUrlParams(urlParams, null, null));
      setLoading(false);
    }
  };

  useEffect(() => {
    setValue(reassignTabValue(tab));
  }, [tab]);

  useEffect(() => {
    setLoading(true);
    const [hasParams, urlParams] = parseUrlParams();
    if (createMode) {
      hasParams ? initializeFromUrlParams(urlParams) : initialize();
    } else {
      initializeFromSaved();
    }
    document.title = `LEAP - ${testRequestId}`;
    return () => {
      document.title = "LEAP";
    };
  }, [testRequestId]);

  useEffect(() => {
    if (value === 0 && !createMode) {
      setLoading(true);
      testRequestApi
        .getTestRequest(testRequestId)
        .then(({ data }) => {
          if (data) {
            updateTestRequestObj(data);
            updateTestRequestTitleSuffix(data.description?.title || "");
            updateTestRequestHistorical(data.historical || false);
          }
        })
        .catch((e) => {
          resetTestRequestContext();
          handleHttpError(e);
        })
        .finally(() => setLoading(false));
    }
  }, [value, testRequestId]);

  const handleChange = (event: unknown, newValue: number): void => {
    const queryParams = new URLSearchParams(window.location.search);
    const opportunityId = queryParams.get("opportunityId") || "";
    const requestType = queryParams.get("requestType") || "";
    const aproe = queryParams.get("aproe") || "";
    const historical = queryParams.get("historical") || "";

    const mergedParams: Record<string, string> = {};
    if (opportunityId) mergedParams.opportunityId = opportunityId;
    if (requestType) mergedParams.requestType = requestType;
    if (aproe) mergedParams.aproe = aproe;
    if (historical) mergedParams.historical = historical;

    let url = `/requests/${testRequestId}/${newValue}`;

    if (createMode && newValue === 0) {
      url = `/requests/${testRequestId}`;
    }

    // Append the query parameters (opportunityId, requestType, aproe) if any exist
    const keys = Object.keys(mergedParams);
    if (keys.length > 0) {
      const queryString = keys.map((key) => `${key}=${encodeURIComponent(mergedParams[key])}`).join("&");
      url += `?${queryString}`;
    }

    if (dirtyFlag) {
      preventNav?.()
        .then(() => {
          history.push(url);
          setValue(newValue);
        })
        .catch((err) => {
          if (err) {
            handleHttpError(err);
          }
        });
    } else {
      history.push(url);
      setValue(newValue);
    }
  };

  const { description } = useContext(TestRequestPermissionContext);

  if (loading) {
    return <CustomProgress />;
  }
  const fullTitle = (testRequestObj.titlePrefix || "") + testRequestTitleSuffix;
  return (
    <div id="requestsPage" className={classes.innerRoot}>
      <div className={classes.subHeader}>
        {testRequestId}
        {testRequestObj?.duplicatedFrom && (
          <>
            {" Duplicated from "}
            <a href={`requests/${testRequestObj?.duplicatedFrom}`} rel="noopener noreferrer" target="_blank">
              {testRequestObj?.duplicatedFrom}
            </a>
          </>
        )}
      </div>
      <div className={classes.headerContainer}>
        <h1 className={classes.h1}>{fullTitle || <span style={{ color: tesaGrey1 }}>- No Title -</span>}</h1>
        {description?.editTitle && tab === TestRequestTabType.DESCRIPTION ? (
          <CreateIcon
            className={classes.createIcon}
            onClick={() => {
              setIsNameDialogOpen(true);
            }}
          />
        ) : (
          <></>
        )}
        {testRequestId === testRequestObj.requestId && <StatusChip status={testRequestObj.status} />}
        <RequestFlagIconList flags={testRequestObj.flags} />
      </div>
      <Box marginTop={2} />
      <EditRequestNameDialog
        open={isNameDialogOpen}
        onClose={() => setIsNameDialogOpen(false)}
        onSave={(newName) => {
          backgroundInformationApi
            .updateBackgroundInformationTitle(testRequestId, newName)
            .then((response) => {
              updateTestRequestTitleSuffix(newName);
              updateTestRequestObj(response.data);
            })
            .catch(handleHttpError)
            .finally(() => setIsNameDialogOpen(false));
        }}
      />
      <AppBar position="static" color="transparent">
        <Tabs
          className={classes.paddingInset}
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          aria-label="create request"
        >
          <Tab
            className={classes.tab}
            disabled={!accessDescription}
            label="Description"
            icon={<AssignmentIcon className={classes.icon} />}
            value={0}
            {...a11yProps(0)}
          />
          {viewSubstrateSamples && (
            <Tab
              className={classes.tab}
              disabled={!accessSubstrateSamples}
              label="Substrate"
              icon={
                value === 1 ? (
                  <SubstrateIconActive className={classes.iconSvg} />
                ) : (
                  <SubstrateIcon className={classes.iconSvg} />
                )
              }
              value={1}
              {...a11yProps(1)}
            />
          )}
          {viewProjectInfo && (
            <Tab
              className={classes.tab}
              disabled={!accessProjectInfo}
              label="Project"
              icon={
                value === 1 ? (
                  <ProjectIconActive className={classes.iconSvg} />
                ) : (
                  <ProjectIcon className={classes.iconSvg} />
                )
              }
              value={1}
              {...a11yProps(1)}
            />
          )}
          {viewProductSamples && (
            <Tab
              className={classes.tab}
              disabled={!accessProductSamples}
              label="Product"
              icon={
                value === 2 ? (
                  <ProductIconActive className={classes.iconSvg} />
                ) : (
                  <ProductIcon className={classes.iconSvg} />
                )
              }
              value={2}
              {...a11yProps(2)}
            />
          )}
          {viewTestPlan && (
            <Tab
              className={classes.tab}
              disabled={!accessTestPlan}
              label="Test"
              icon={<CompareArrowsIcon className={classes.icon} />}
              value={3}
              {...a11yProps(3)}
            />
          )}
          {viewReports && (
            <Tab
              className={classes.tab}
              disabled={!accessReports}
              label={(testRequestObj?.purpose || "DEFAULT") === "DEFAULT" ? "Report" : "Solution"}
              icon={<InsertChartIcon className={classes.icon} />}
              value={4}
              {...a11yProps(4)}
            />
          )}
          {viewHistory && (
            <Tab
              className={classes.tab}
              disabled={!accessHistory}
              label="History"
              icon={<HistoryIcon className={classes.icon} />}
              value={5}
              {...a11yProps(5)}
            />
          )}
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <DescriptionTab initialValuesFromUrl={initialValuesFromUrl} key={refreshKey} />
      </TabPanel>
      <ProductProvider>
        <SubstrateSampleProvider>
          <TabPanel value={value} index={1}>
            {viewSubstrateSamples && (
              <SubstrateSampleProvider>
                <SubstrateTab />
              </SubstrateSampleProvider>
            )}
            {viewProjectInfo && <AproeProjectTab />}
          </TabPanel>
          <TabPanel value={value} index={2}>
            <ProductProvider>
              <ProductTab />
            </ProductProvider>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <TestPlanPermissionContextProvider testRequestId={testRequestId}>
              <TestSeriesProvider>
                <TestTab />
              </TestSeriesProvider>
            </TestPlanPermissionContextProvider>
          </TabPanel>
        </SubstrateSampleProvider>
      </ProductProvider>
      <TabPanel value={value} index={4}>
        <ReportTab />
      </TabPanel>
      {accessHistory && (
        <TabPanel value={value} index={5}>
          <HistoryTab />
        </TabPanel>
      )}
    </div>
  );
};

export default RequestsPage;
